<button class="ellipsis" mat-button [matMenuTriggerFor]="menu" (menuOpened)="menuOpened()" *ngIf="showButton$ | async">
  <span fxLayout fxLayoutAlign="space-between center" fxFlex>
    <span fxFlex class="ellipsis">
      {{ (tempValue?.type === 'groups' ? 'controls.groupsSelected' : 'controls.usersSelected') | translate:{count:
      tempValue?.count || 0, all: tempValue?.all} }}
    </span>
    <mat-icon style="margin-left: 6px;" fxFlex="0 0 auto">keyboard_arrow_down</mat-icon>
  </span>
</button>


<mat-menu #menu="matMenu" class="dropdown-menu" (closed)="menuClosed()">
  <ng-container *ngIf="showGroups && showUsers; else flatView">
    <mat-tab-group fxFlex="0 0 auto" mat-align-tabs="center" [selectedIndex]="tempValue?.type === 'groups' ? 1 : 0"
      animationDuration="0" (selectedTabChange)="typeChanged($event)" (click)="$event.stopPropagation()">
      <mat-tab [label]="'common.users' | translate"></mat-tab>
      <mat-tab [label]="'common.groups' | translate"></mat-tab>
    </mat-tab-group>

    <ng-container *ngIf="tempValue?.type === 'groups'; else userTab">
      <ng-container *ngTemplateOutlet="groupTab"></ng-container>
    </ng-container>
  </ng-container>
</mat-menu>

<ng-template #flatView>
  <ng-container *ngTemplateOutlet="showUsers ? userTab : groupTab"></ng-container>
</ng-template>

<ng-template #userTab>
  <app-search [ngModel]="filter$" rxModel stopPropagation></app-search>

  <ng-container *ngIf="(usersToShow$ | async) as users">
    <ng-container *ngIf="users.length; else noUsers">
      <mat-checkbox class="column-checkbox all-checkbox" (click)="$event.stopPropagation()" color="primary"
        (change)="masterToggle($event.checked)" [checked]="tempValue.users.all"
        [indeterminate]="tempValue.users.indeterminate">
        <strong>{{ 'controls.allUsers' | translate }}</strong>
      </mat-checkbox>

      <mat-divider></mat-divider>

      <cdk-virtual-scroll-viewport #userVs [itemSize]="40" [style.height.px]="users.length * 40" minBufferPx="200"
        maxBufferPx="400">
        <mat-checkbox *cdkVirtualFor="let user of users" class="column-checkbox" (click)="$event.stopPropagation()"
          color="primary" (change)="setSelected($event.checked, user.id)"
          [checked]="tempValue.users.isSelected(user.id)">
          {{ user.name }}
        </mat-checkbox>
      </cdk-virtual-scroll-viewport>
    </ng-container>


    <ng-template #noUsers>
      <div class="empty-message">
        {{ 'common.noUsersFound' | translate }}
      </div>
    </ng-template>
  </ng-container>
</ng-template>


<ng-template #groupTab>
  <app-search [ngModel]="filter$" rxModel stopPropagation></app-search>

  <ng-container *ngIf="(groupsToShow$ | async) as groups">
    <ng-container *ngIf="groups.length; else noGroups">
      <mat-checkbox class="column-checkbox all-checkbox" (click)="$event.stopPropagation()" color="primary"
        (change)="masterToggle($event.checked)" [checked]="tempValue.groups.all">
        <strong>{{ 'controls.allGroups' | translate }}</strong>
      </mat-checkbox>

      <mat-checkbox class="column-checkbox all-checkbox" (click)="$event.stopPropagation()" color="primary"
        (change)="setSelected($event.checked, membersOfNoGroupId)"
        [checked]="tempValue.groups.isSelected(membersOfNoGroupId)">
        <truncated-text [text]="'controls.membersOfNoGroup' | translate"></truncated-text>
      </mat-checkbox>

      <mat-divider></mat-divider>

      <cdk-virtual-scroll-viewport #groupVs [itemSize]="40" minBufferPx="200" maxBufferPx="400"
        [style.height.px]="groups.length * 40">
        <mat-checkbox *cdkVirtualFor="let group of groups" class="column-checkbox" (click)="$event.stopPropagation()"
          color="primary" (change)="setSelected($event.checked, group.id)"
          [checked]="tempValue.groups.isSelected(group.id)">
          <truncated-text [text]="group.name"></truncated-text>
        </mat-checkbox>
      </cdk-virtual-scroll-viewport>
    </ng-container>

    <ng-template #noGroups>
      <div class="empty-message">
        {{ ((filter$ | async) ? 'common.noGroupsFound' : 'common.noGroupsAvailableAndAsk') | translate }}
      </div>
    </ng-template>
  </ng-container>
</ng-template>
